/**
 * @description 活跃用户 activeUser
 * @author xiehan
 * @date 2019/11/27
 */

import Logic from '../logic-base'

const ALBTargetGroupManagerBiz = new Logic()

ALBTargetGroupManagerBiz.queryAppInfo = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.ALBTargtGroupManager.queryAppInfo,
    data: data
  })
}

ALBTargetGroupManagerBiz.getGroup = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.ALBTargtGroupManager.getGroup,
    data: data
  })
}

ALBTargetGroupManagerBiz.getApp = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.ALBTargtGroupManager.getApp,
    data: data
  })
}

ALBTargetGroupManagerBiz.batchDelete = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.ALBTargtGroupManager.batchDelete,
    data: data
  })
}

ALBTargetGroupManagerBiz.deleteInstance = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.ALBTargtGroupManager.deleteInstance,
    data: data
  })
}

ALBTargetGroupManagerBiz.queryFreeInstance = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.ALBTargtGroupManager.queryFreeInstance,
    data: data
  })
}

ALBTargetGroupManagerBiz.queryOfflineInstance = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.ALBTargtGroupManager.queryOfflineInstance,
    data: data
  })
}

ALBTargetGroupManagerBiz.queryOnlineInstance = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.ALBTargtGroupManager.queryOnlineInstance,
    data: data
  })
}

ALBTargetGroupManagerBiz.saveGroupRelateInfo = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.ALBTargtGroupManager.saveGroupRelateInfo,
    data: data
  })
}

ALBTargetGroupManagerBiz.getGroupRelateInfo = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.ALBTargtGroupManager.getGroupRelateInfo,
    data: data
  })
}

ALBTargetGroupManagerBiz.getUpdateTargetGroup = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.ALBTargtGroupManager.getUpdateTargetGroup,
    data: data
  })
}

ALBTargetGroupManagerBiz.updateTargetGroup = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.ALBTargtGroupManager.updateTargetGroup,
    data: data
  })
}

export default ALBTargetGroupManagerBiz
